module.exports = __webpack_public_path__ + "lastSlideLeft.webp?3e76ee1d0b8d79e91a5901d2fa866a10";